import React, { useRef } from "react";
// import CkEditor from "./AiEditor/CkEditor";

function TestEditior() {
  const editorContent = useRef([""]);
  //console.log("editorContent", editorContent);
  const editorRef = useRef(null);
  const handleEditorReady = (editor) => {
    editorRef.current = editor;
  };

  return (
    <div>
      {/* <CkEditor
        editorContent={editorContent}
        editorRef={editorRef}
        handleEditorReady={handleEditorReady}
      /> */}
    </div>
  );
}

export default TestEditior;
